var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAfterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 98,
    viewBox: "0 0 110 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: 6.04116,
    y: -6.9,
    width: 110.859,
    height: 96.9215
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(3.45px)",
      clipPath: "url(#bgblur_0_11846_111905_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 6.9,
    d: "M109.5 0.5V48.2031L94.8376 82.6211H74.5837L82.0183 48.4121L82.1501 47.8057H67.9929V0.5H109.5ZM54.948 0.5V48.2031L40.2849 82.6211H20.2283L27.4666 48.4092L27.5945 47.8057H13.4412V0.5H54.948Z",
    fill: "#23262F",
    fillOpacity: 0.6,
    stroke: "#353945"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -12,
    y: 2.87854,
    width: 121.059,
    height: 107.121
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6px)",
      clipPath: "url(#bgblur_1_11846_111905_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 12,
    d: "M96.5586 15.3785V63.0817L81.8965 97.4996H61.6426L69.0771 63.2906L69.209 62.6842H55.0518V15.3785H96.5586ZM42.0068 15.3785V63.0817L27.3438 97.4996H7.28711L14.5254 63.2877L14.6533 62.6842H0.5V15.3785H42.0068Z",
    stroke: "#5834A8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_11846_111905_clip_path",
    transform: "translate(-6.04116 6.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.5 0.5V48.2031L94.8376 82.6211H74.5837L82.0183 48.4121L82.1501 47.8057H67.9929V0.5H109.5ZM54.948 0.5V48.2031L40.2849 82.6211H20.2283L27.4666 48.4092L27.5945 47.8057H13.4412V0.5H54.948Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_11846_111905_clip_path",
    transform: "translate(12 -2.87854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.5586 15.3785V63.0817L81.8965 97.4996H61.6426L69.0771 63.2906L69.209 62.6842H55.0518V15.3785H96.5586ZM42.0068 15.3785V63.0817L27.3438 97.4996H7.28711L14.5254 63.2877L14.6533 62.6842H0.5V15.3785H42.0068Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfterIcon);
export default __webpack_public_path__ + "static/media/afterIcon.74e35fb9a34610e4f22580b6d365e9ea.svg";
export { ForwardRef as ReactComponent };